module.exports = __webpack_public_path__ + "static/media/selectedBusStopIcon.75588471.png";